export default __webpack_public_path__ + "static/media/Rectangle 7.cfc6cda9.png";